import BlogIndex from './BlogIndex'

export default BlogIndex
